// removed by extract-text-webpack-plugin
module.exports = {"tabItem":"details__tabItem--34-pr","schema-details-container":"details__schema-details-container--36Wss","schema-details-header":"details__schema-details-header--aeeee"};


//////////////////
// WEBPACK FOOTER
// ./src/client/plugins/structured-data/components/styles/details.scss
// module id = Kj3X
// module chunks = 23